import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {ConnectedRouter} from 'connected-react-router';
import {Provider} from 'react-redux';
import App from './App';

import {ApplyTheme} from './theme'

import {Route, Switch} from "react-router-dom";


if (process.env.NODE_ENV === 'development') {
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  const ReactRedux = require('react-redux');
  whyDidYouRender(React, {
    trackAllPureComponents: false,
    trackExtraHooks: [
      [ReactRedux, 'useSelector']
    ]
  });
}

export default class Root extends Component {
  render() {
    const {store, history} = this.props;
    return (
      <ApplyTheme>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <Switch>
              <Route 
                path={'/'} 
                component={App}
              />
            </Switch>
          </ConnectedRouter>
        </Provider>
      </ApplyTheme>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};
